import * as React from 'react';
import {Icon} from '@iconify/react';
import TextareaAutosize from 'react-textarea-autosize';
import './Input.sass';


export interface IInputProps {
    onSubmit: (value: string | any) => void;
    // onHeightChange: (height: number) => void;
    placeholder: string;
    disabled: boolean;
    icon: string;
}


export const InputComponent: React.FC<IInputProps> = (props) => {
    const [message, setMessage] = React.useState<string>('');


    function catchEnterKey(e: any) {
        if (!e.shiftKey && e.key === 'Enter') {
            e.preventDefault();
            handleSend();
        }
    }


    function handleSend() {
        props.onSubmit(message.trim());
        setMessage('');
    }


    function handleInputChange(e: any) {
        if (e.target.value.length < 1024) {
            setMessage(e.target.value);
        }
    }


    return (
        <span className={'mvc-input-component'}>
            {/*<TextareaAutosize />*/}
            <TextareaAutosize
                key={'input'}
                disabled={props.disabled}
                className={'mvc-input-text'}
                placeholder={props.placeholder}
                value={message}
                onKeyDown={catchEnterKey}
                onChange={handleInputChange}
                //ToDo: This is a crime scene!!!
                maxRows={message.length ? undefined : 1}
            />
      <Icon
          key={'icon'}
          onClick={handleSend}
          className={'mvc-input-text-send-icon'}
          icon={props.icon}
          height={20}
          color={'white'}
      />
    </span>
    );
};
